import { useApolloClient } from '@apollo/client'

const GetApolloClient = (props) => {
    const client = useApolloClient()
    return props.children(client)
}

export default GetApolloClient